import React from 'react';
import CommentItem from './CommentItem';

const CommentList = ({
  comments,
  currentUser,
  onEdit,
  onDelete,
  onReply,
  onReaction,
  depth = 0
}) => {
  if (!comments || comments.length === 0) {
    return null;
  }

  return (
    <div className="space-y-0">
      {comments.map((comment) => (
        <div key={comment.id}>
          <CommentItem
            comment={comment}
            currentUser={currentUser}
            onEdit={onEdit}
            onDelete={onDelete}
            onReply={onReply}
            onReaction={onReaction}
            depth={depth}
          />
          {/* Recursively render replies */}
          {comment.replies && comment.replies.length > 0 && (
            <CommentList
              comments={comment.replies}
              currentUser={currentUser}
              onEdit={onEdit}
              onDelete={onDelete}
              onReply={onReply}
              onReaction={onReaction}
              depth={depth + 1}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default CommentList;
